import './styles.scss';

const Prefooter = ({ title, text, button, onClick }) => {
  return (
    <div className='preFooter'>
      <span className='preFooterTitle'>{title}</span>
      <span className='preFooterText'>{text}</span>
      <span className='preFooterButton' onClick={onClick}>
        {button}
      </span>
    </div>
  );
};

export default Prefooter;
